export const VERSION=process.env.REACT_APP_GIT_SHA;